import * as enquire from 'enquire.js';
/**
 * 监听设备尺寸变化
 * @param callback 回调函数
 */
export function deviceEnquire(callback) {
  enquire.register('only screen and (max-width: 576px)', function () {
    return callback && callback('xs');
  });
  enquire.register('only screen and (min-width: 576px) and (max-width: 767px)', function () {
    return callback && callback('sm');
  });
  enquire.register('only screen and (min-width: 768px) and (max-width: 991px)', function () {
    return callback && callback('md');
  });
  enquire.register('only screen and (min-width: 992px) and (max-width: 1199px)', function () {
    return callback && callback('lg');
  });
  enquire.register('only screen and (min-width: 1200px) and (max-width: 1599px)', function () {
    return callback && callback('xl');
  });
  enquire.register('only screen and (min-width: 1600px)', function () {
    return callback && callback('xxl');
  });
}
export default {
  deviceEnquire: deviceEnquire
};